export default function Marques() {
  const marques = ["Somfy", "Nice", "Simu", "Bubendorff", "Profalux", "Elero"];

  return (
    <section className="bg-white py-12 md:py-16 border-y border-brand-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-xl md:text-2xl font-bold text-center mb-4">
          Les marques que nous réparons
        </h2>
        <p className="text-brand-text text-base leading-relaxed text-center max-w-2xl mx-auto mb-8 md:mb-10">
          Quelle que soit la marque de votre volet roulant, nous avons les pièces compatibles et l'expertise nécessaire pour réparer. Somfy, Nice, Simu, Bubendorff, Profalux ou Elero : nous connaissons les spécificités de chaque motorisation et mécanisme pour intervenir efficacement.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {marques.map((m) => (
            <span key={m} className="text-brand-text/40 text-lg md:text-xl font-bold uppercase tracking-wider">
              {m}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}